(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5616],{

/***/ 966:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/news/[id]",
      function () {
        return __webpack_require__(61835);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60306);
/* harmony import */ var _Layout_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24987);



function AirlineArticle(param) {
    var article = param.article, recommendation = param.recommendation, setLoginDialogState = param.setLoginDialogState, authCompleted = param.authCompleted;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_1__/* .Article */ .d2, {
        article: article,
        recommendation: recommendation,
        setLoginDialogState: setLoginDialogState,
        authCompleted: authCompleted
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_Layout_Layout__WEBPACK_IMPORTED_MODULE_2__/* .withLayout */ .X)(AirlineArticle, false));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7601,9125,6700,632,9780,6420,4987,9774,2888,179], function() { return __webpack_exec__(966); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);